<template>
    <div class="flex flex-col md:flex-row">
        <aside class="w-full md:w-220px">
            <h5 class="mt-0">{{ $t('globals.sections') }}</h5>
            <div class="list-group">
                <a class="list-group-item px-2 py-2" :class="{ active : (hash === 'active-users' || hash === '') }" href="javascript:;" @click="setHash('active-users')">
                    <span class="icon icon-check icon-lg icon-fw"></span>
                    {{ $t('users.active_users') }}
                </a>
                <a class="list-group-item px-2 py-2" :class="{ active : hash === 'deleted-users' }" href="javascript:;" @click="setHash('deleted-users')">
                    <span class="icon icon-times icon-lg icon-fw"></span>
                    {{ $t('users.deleted_users') }}
                </a>
                <a v-if="userAdminsOrganization" class="list-group-item px-2 py-2" :class="{ active : hash === 'join-requests' }" href="javascript:;" @click="setHash('join-requests')">
                    <span v-if="pendingJoinRequestsCount > 0" class="badge badge-primary pull-right">{{ pendingJoinRequestsCount }}</span>
                    <span class="icon icon-spinner icon-lg icon-fw"></span>
                    {{ $t('users.join_requests') }}
                </a>
            </div>
            <div v-if="userAdminsOrganization" class="mt-5">
                <button @click="openInviteUserModal" class="btn btn-outline-primary btn-block my-2">
                    {{ $t('users.invite_user') }}
                </button>
            </div>
        </aside>
        <div class="flex-1 md:pl-15px">
            <div v-if="hash === 'active-users' || hash === ''">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('users.active_users') }}</h4>
                    <p class="mb-0">{{ $t('users.active_users_info') }}</p>
                </div>
                <div>
                    <active-users-list :users="activeUsers" :applications="applications" :initial-roles="initialRoles"></active-users-list>
                </div>
            </div>
            <div v-else-if="hash === 'deleted-users'">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('users.deleted_users') }}</h4>
                    <p class="mb-0">{{ $t('users.deleted_users_info') }}</p>
                </div>
                <div>
                    <deleted-users-list :users="deletedUsers"></deleted-users-list>
                </div>
            </div>
            <div v-else-if="hash === 'join-requests' && userAdminsOrganization">
                <div class="mb-4">
                    <h4 class="mt-0 mb-1">{{ $t('users.join_requests') }}</h4>
                    <p class="mb-0">{{ $t('users.join_requests_info') }}</p>
                </div>
                <div>
                    <join-requests-list :join-requests="joinRequests"></join-requests-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ActiveUsersList from './partials/active-users-list.vue';
import DeletedUsersList from './partials/deleted-users-list.vue';
import JoinRequestsList from './partials/join-requests-list.vue';

export default {
    components: {
        'active-users-list': ActiveUsersList,
        'deleted-users-list': DeletedUsersList,
        'join-requests-list': JoinRequestsList,
    },

    props: {
        activeUsers: {
            type: Array,
            required: true,
        },
        applications: {
            type: Array,
            required: true,
        },
        deletedUsers: {
            type: Array,
            required: true,
        },
        joinRequests: {
            type: Array,
            required: true,
        },
        initialRoles: {
            type: Array,
            required: true,
        },
        pendingJoinRequestsCount: {
            type: Number,
        },
    },

    data() {
        return {
            hash: window.location.hash.substr(1),
        };
    },

    computed: {
        userAdminsOrganization() {
            return window.Globals.user.id === window.Globals.user.organization.owner_id || window.Globals.user.is_admin;
        }
    },

    created() {
        window.addEventListener('popstate', () => {
            const hash = window.location.hash.substr(1);
            this.broadcastHashChange(hash);
        });
    },

    methods: {
        setHash(hash) {
            window.history.pushState(null, null, `#${hash}`);
            this.broadcastHashChange(hash);
        },

        broadcastHashChange(hash) {
            this.hash = hash;
        },

        openInviteUserModal() {
            Bus.$emit('showInviteUserModal');
        },
    }
};
</script>
